var map = {
	"./links.png": 24,
	"./long-portfolio-1.jpg": 25,
	"./long-portfolio-2.jpg": 26,
	"./long-portfolio-3.jpg": 27,
	"./long-portfolio-4.jpg": 28,
	"./long-portfolio-5.jpg": 29,
	"./mail.png": 30,
	"./masonry-portfolio-1.jpg": 31,
	"./masonry-portfolio-10.jpg": 32,
	"./masonry-portfolio-11.jpg": 33,
	"./masonry-portfolio-12.jpg": 34,
	"./masonry-portfolio-13.jpg": 35,
	"./masonry-portfolio-14.jpg": 36,
	"./masonry-portfolio-15.jpg": 37,
	"./masonry-portfolio-2.jpg": 38,
	"./masonry-portfolio-3.jpg": 39,
	"./masonry-portfolio-4.jpg": 40,
	"./masonry-portfolio-5.jpg": 41,
	"./masonry-portfolio-6.jpg": 42,
	"./masonry-portfolio-7.jpg": 43,
	"./masonry-portfolio-8.jpg": 44,
	"./masonry-portfolio-9.jpg": 45,
	"./portfolio-1.jpg": 46,
	"./portfolio-10.jpg": 47,
	"./portfolio-11.jpg": 48,
	"./portfolio-12.jpg": 49,
	"./portfolio-13.jpg": 50,
	"./portfolio-14.jpg": 51,
	"./portfolio-15.jpg": 52,
	"./portfolio-2.jpg": 53,
	"./portfolio-3.jpg": 54,
	"./portfolio-4.jpg": 55,
	"./portfolio-5.jpg": 56,
	"./portfolio-6.jpg": 57,
	"./portfolio-7.jpg": 58,
	"./portfolio-8.jpg": 59,
	"./portfolio-9.jpg": 60,
	"./portfolio-embrace.png": 61,
	"./portfolio-etta.png": 62,
	"./portfolio-haken.png": 63,
	"./portfolio-missing.png": 64,
	"./portfolio-schindlers.png": 65,
	"./portfolio-tears.png": 66,
	"./portfolio-thousand.png": 67,
	"./portfolio-tool.png": 68,
	"./portfolio-walking.png": 69,
	"./visuals.png": 70
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84;